import 'angular:locale/data:de-DE';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "de-DE";
